<template>
<div>
    <b-row><b-col cols="6"><fg-input v-model="item.id" :label="$t('timetables.id')" :disabled="true"></fg-input></b-col> </b-row>
    <fg-input v-model="values.name" :label="$t('infopointlayouts.name')" :disabled="loading"></fg-input>
    <b-row>
        <b-col>
            <SelectList :label="$t('infopointlayouts.orientation.label')" :options="orientationOptions" :value="values.orientation" @select="selectOrientation" :searchable="false" :clearable="false" :disabled="loading"/>
        </b-col>
        <b-col><fg-input v-model="values.rows" :label="$t('infopointlayouts.rows')" :disabled="loading"></fg-input></b-col>
    </b-row>
    <b-row>
        <b-col><fg-input v-model="values.width" :label="$t('infopointlayouts.width')" :disabled="loading"></fg-input></b-col>
        <b-col><fg-input v-model="values.height" :label="$t('infopointlayouts.height')" :disabled="loading"></fg-input></b-col>
    </b-row>

    <t-button type="save" @click="save" :disabled="!changed || loading"></t-button> 
    <RequestInfo type="save" :ok="OK" :error="ERROR" :loader="loading" />  
    
</div>
</template>
    
<script>
export default {
    props: ['item'],
    data: function() {
        return {
            loading: false,
            OK: false,
            ERROR: false,
            orientationOptions: [
                { id: 'HORIZONTAL', label: this.$t('infopointlayouts.orientation.HORIZONTAL'), icon: 'arrow-left-right' },
                { id: 'VERTICAL', label: this.$t('infopointlayouts.orientation.VERTICAL'), icon: 'arrow-down-up' },
                { id: 'RESPONSIVE', label: this.$t('infopointlayouts.orientation.RESPONSIVE'), icon: 'asterisk' },
            ],
            values: {}
        }
    },
    created() {
        this.copyItem();
    },
    watch: {
        item(){
            this.copyItem();
        }
    },
    computed: {
        changed(){
            return this.item.name != this.values.name 
                || this.item.orientation != this.values.orientation
                || this.item.rows != this.values.rows
                || this.item.width != this.values.width
                || this.item.height != this.values.height;
        }
    },
    methods: {
        copyItem() {
            if (this.item) {
                this.values = JSON.parse(JSON.stringify(this.item));
            }
            
        },
        updateItem(){
             if (this.item && this.values) {
                this.item.name = this.values.name;
                this.item.orientation = this.values.orientation;
                this.item.rows = this.values.rows;
                this.item.width = this.values.width;
                this.item.height = this.values.height;
             }
        },
        selectOrientation(value){
             this.values.orientation = value;
        },
        save() {
            this.loading = true;
            this.$traveller_http.post('/traveller/restui/infopointlayout/save', this.values  )
            .then( response => {
                this.OK = response.data.errorCode == 0;
                this.ERROR = !this.OK;
                if(this.OK){
                    this.updateItem();
                }
            })
            .catch( () => { this.ERROR = true; } ) 
            .finally( () => { this.loading = false; } ); 

        }
    }
}
</script>
    